import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { FaInfoCircle } from "react-icons/fa";


const SpecialNotes = ({ notes }) => {
  return (
    <Paper elevation={3} sx={{ padding: 3, maxWidth: 600, margin: '20px auto', backgroundColor: '#f9f9f9' }}>
      <Box display="flex" alignItems="center" mb={2}>
        <FaInfoCircle color='#1976d2' size={18} />
        <Typography variant="h6" color="primary">
          Special Notes
        </Typography>
      </Box>
      <Typography variant="body1" color="textSecondary">
        {notes}
      </Typography>
    </Paper>
  );
};

export default SpecialNotes;
